// sync to https://github.com/pingcap-inc/compute-engine/blob/master/jobs/health-report-v2/app.py#L284
export const unitMap: { [k: string]: string } = {
  '1': 'none',
  '%': 'percent',
  Bytes: 'bytes',
  Bps: 'Bps',
  s: 's'
}
